type CartLine = { rateId: string; purchasedNumber?: number | null } | undefined;
type AddOnRate = { id: string };

export const splitCartQuantities = (
  ticketsPurchased: readonly CartLine[] | undefined,
  addOnRateIds: ReadonlySet<string>
): { itemsCount: number; addOnsCount: number } => {
  let itemsCount = 0;
  let addOnsCount = 0;
  for (const line of ticketsPurchased ?? []) {
    if (!line) {
      continue;
    }
    if (addOnRateIds.has(line.rateId)) {
      addOnsCount += line.purchasedNumber || 0;
    } else {
      itemsCount += line.purchasedNumber || 0;
    }
  }
  return { itemsCount, addOnsCount };
};

export const getFormAddOnAnalytics = (
  addOnRates: readonly AddOnRate[],
  ticketsPurchased: readonly CartLine[] | undefined
): { availableAddOnsCount: number; itemsCount: number; addOnsCount: number } => {
  const addOnRateIds = new Set(addOnRates.map((rate) => rate.id));
  return { availableAddOnsCount: addOnRates.length, ...splitCartQuantities(ticketsPurchased, addOnRateIds) };
};
